import styled from 'styled-components';
import { getToken, Stack, StackItem, getSpacingToken } from '@optimus-web/core';
import { HIDDEN_PRINT } from '../../../../components/commander-ui/constants';

export const BackgroundContainer = styled.div`
    min-height: 100%;
`;

export const ContentWrapper = styled.div`
    min-height: 0;
    flex: 1 1 auto;
`;

export const WrapperStack = styled(Stack)`
    ${HIDDEN_PRINT}
`;

export const BulkActionsWrapper = styled.div`
    background: ${getToken('backgroundStaticFlat')};
    border-bottom: solid 1px ${getToken('paletteBrandNight100')};
`;
/* Hack! Fixed (fake) height triggers overflow condition, however real height is calculated from flex layout. */
export const OverflowStackItem = styled(StackItem)`
    overflow: auto;
    height: 10px;
`;
export const ScrollableContentWrapper = styled.div`
    margin-bottom: ${getSpacingToken('100')}px;
    box-shadow: ${getToken('shadow100')};
    min-height: calc(100% - ${getSpacingToken('100')}px);
    background: ${getToken('backgroundStaticFlat')};
`;

export interface WithOffset {
    offset?: number;
}

export const Offset = styled.div<WithOffset>`
    padding-left: ${({ offset, theme }) => (offset ?? 0) * getSpacingToken('200')({ theme })}px;
`;

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    @media print {
        height: auto;
    }
`;

export const ScrollableColumnContent = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

    @media print {
        position: static;
    }
`;
